<<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights"/><list-panel @updateIdx="updateIdx" :selIdx="selIdx" :config="config" :isAutoLoad='1' :rs="rs" />
    <component v-if="isShowDetail" v-bind:is="detailView" :url="config.url" @back="back" :comList="comList" :ucList="ucList"
     :roleList='roleList' :action="detailAction" :detailData="detailData" :rs="rs" >
        <a class="btn btn-default" @click="back">{{$rs["btn_back"]}}</a>
    </component>
</div>
</template>


<script>
import data from "./data";
import detail from "./detail"
import mixin from "../../mixin/listMixin.js"

export default {
  mixins:[mixin],
  data() {
    return {
      config: data,
      roleList: null,
      ucList:null,
      comList: null
    };
  },
  methods: {
    initDetail(el){
      let uno
      if (el && el.userNo) uno=el.userNo
      else uno = 0

      if (this.detailAction != "Add"){
      }
      this.$getData(this.config.url + "roleList?userNo=" + uno + this.$urlSq(), this.openDetail)
    },
    openDetail(data){
      if (data && data.rs) {
        this.roleList = data.roleList
        this.comList = data.comList
        this.ucList = data.ucList
        this.isShowDetail = true;
      }
    }
  },
  components: {
    "detail-panel": detail
  }
};
</script>
